import {CheckboxOption, HeatingCurvePoint, ScheduleInterval} from "./controls";

export enum MenuType {
    MU = "MU",
    MI = "MI",
    MS = "MS",
    MP = "MP",
}

export enum MenuTypeKey {
    MU = 'menu',
    MI = 'fitters_menu',
    MS = 'service_menu',
    MP = 'manufacturer_menu',
}

export type PinData = {
    menuType: MenuType,
    pin: string,
    id: number,
    udid: string,
}

export type MenuParent = {
    type: MenuType,
    id: number,
}

export type MenuDate = {
    date: Date
    dateString: string
}

export type MenuResponse ={
    data?: {
        elements: MenuElement[],
        transaction_time: string,
    }
    status?: "success",
    message?: string
}

export type MainMenu = {
    [key in MenuType]?: MenuElement[]
}

export type MenuHelper = {
    value: string,
    brotherElement: Array<unknown>,
}

export type MenuElementBase = {
    access: boolean;
    duringChange: 'f' | 't' | null;
    iconId: number;
    id: number;
    menuType: MenuType;
    parentId: number;
    txtId: number;
    wikiTxtId: number;
    password?: 'validPass';
    checked?: boolean;
};

export type MenuElement =
    | MenuParentElement
    | MenuElementType1_5
    | MenuElementType6
    | MenuElementType7
    | MenuElementType10
    | MenuElementType11_111
    | MenuElementType12
    | MenuElementType13
    | MenuElementType15
    | MenuElementType20
    | MenuElementType28
    | MenuElementType29
    | MenuElementType30
    | MenuElementType31
    | MenuElementType32
    | MenuElementType35
    | MenuElementType45
    | MenuElementType46
    | MenuElementType50
    | MenuElementType100
    | MenuElementType106
    | MenuElementType107
    | MenuElementType108
    | MenuElementType109
    | MenuElementType112
    | MenuElementType120;

export type MenuParentParams = {
    type: 0;
    params: {
        description: string;
        password?: string;
    };
};

export type MenuParentElement = MenuElementBase & MenuParentParams;

export type MenuElementParamsType1_5 = {
    format: number;
    value: number;
    min: number;
    max: number;
    default: number;
    txtId: number;
    description: string;
};

export type MenuElementType1_5 = MenuElementBase & {
    type: 1 | 2 | 3 | 4 | 5;
    params: MenuElementParamsType1_5;
};

export type MenuElementParamsType6 = {
    state: 0 | 1 | 2 | 3 | 4;
    code: number;
    stateTxtId: number;
    blockHide?: 0 | 1;
};

export type MenuElementType6 = MenuElementBase & {
    type: 6;
    params: MenuElementParamsType6;
};

export type MenuElementParamsType7 = {
    format: number;
    remoteReset: boolean;
    value: number;
    min: number;
    max: number;
    default: number;
    type: number;
    timeValue: number;
    timeMin: number;
    timeMax: number;
    timeDefault: number;
    description: string;
};

export type MenuElementType7 = MenuElementBase & {
    type: 7;
    params: MenuElementParamsType7;
};

export type MenuElementParamsType10 = {
    value: 0 | 1;
    default: 0 | 1;
    description: string;
};

export type MenuElementType10 = MenuElementBase & {
    type: 10;
    params: MenuElementParamsType10;
};

export type ParamsOption = {
    txtId: number;
    value: number;
    checked?: boolean;
};

export type MenuElementParamsType11_111 = {
    value: number;
    default: number;
    options: ParamsOption[];
    description: string;
};

export type MenuElementType11_111 = MenuElementBase & {
    type: 11 | 111;
    params: MenuElementParamsType11_111;
};

export type MenuElementParamsType12 = {
    dayId: 0 | 1 | 2 | 3 | 4 | 5 | 6;
    prevObjId: number;
    nextObjId: number;
    valueObjId: number;
    min: number;
    max: number;
    values: number[];
    description: string;
};

export type MenuElementType12 = MenuElementBase & {
    type: 12;
    params: MenuElementParamsType12;
};

export type MenuElementParamsType13 = {
    dayId: 0 | 1 | 2 | 3 | 4 | 5 | 6;
    prevObjId: number;
    nextObjId: number;
    value: number;
    default: number;
    noZones: 24 | 48;
    daySubtitles: 0 | 1;
    description: string;
};

export type MenuElementType13 = MenuElementBase & {
    type: 13;
    params: MenuElementParamsType13;
};


export type MenuElementsParamsType15 = {
    default: number;
    description: string;
    options: number[];
    value: number;
};
export type MenuElementType15 = MenuElementBase & {
    type: 15;
    params: MenuElementsParamsType15;
};

export type MenuElementParamsType20 = {
    txtId: number;
    type: 0 | 1 | 2;
    value: number;
    blockHide: 0 | 1 | null;
    description: string;
};

export type MenuElementType20 = MenuElementBase & {
    type: 20;
    params: MenuElementParamsType20;
};

export type MenuElementParamsType28 = {
    min: number;
    max: number;
    unit: number;
    points: HeatingCurvePoint[];
    description: string;
}

export type MenuElementType28 = MenuElementBase & {
    type: 28;
    params: MenuElementParamsType28;
};

export type MenuElementParamsType29 = {
    slope: number;
    slopeMin: number;
    slopeMax: number;
    shift: number;
    shiftMin: number;
    shiftMax: number;
    setTemp: number;
    externalTemp: number;
    resultingTemperatureMin: number;
    resultingTemperatureMax: number;
    constant1: number;
    constant2: number;
    constant3: number;
    constant4: number;
    constant5: number;
    patternId: number;
    xMin: number;
    xMax: number;
    yMin: number;
    yMax: number;
};

export type MenuElementType29 = MenuElementBase & {
    type: 29;
    params: MenuElementParamsType29;
};

export type MenuElementParamsType30 = {
    min: number;
    max: number;
    points: HeatingCurvePoint[];
    description: string;
};
export type MenuElementType30 = MenuElementBase & {
    type: 30;
    params: MenuElementParamsType30;
};

export type MenuElementsParamsType31 = {
    slope: number;
    minSlope: number;
    maxSlope: number;
    defaultSlope: number;
    shift: number;
    minShift: number;
    maxShift: number;
    defaultShift: number;
    maxValue: number;
    description: string;
};

export type MenuElementType31 = MenuElementBase & {
    type: 31;
    params: MenuElementsParamsType31;
};

export type MenuElementParamsType32 = {
    groupCode: string | null;
};

export type MenuElementType32 = MenuElementBase & {
    type: 32;
    params: MenuElementParamsType32;
};

export type MenuElementParamsType35 = {
    description: string;
    password: string;
}

export type MenuElementType35 = MenuElementBase & {
    type: 35;
    params: MenuElementParamsType35;
};

export type ColumnDefinitionType45 = {
    idSubtitle: number;
    type: number;
};

export type MenuElementParamsType45 = {
    noCols: number;
    noRows: number;
    colsDef: ColumnDefinitionType45[];
    rowsData: Array<number[]>;
    description: string;
};

export type MenuElementType45 = MenuElementBase & {
    type: 45;
    params: MenuElementParamsType45;
};

export type RowDataType46 = {
    value: number;
    type: number;
};

export type MenuElementParamsType46 = {
    noCols: number;
    noRows: number;
    colsDef: number[];
    rowsData: Array<RowDataType46[]>;
    description: string;
};

export type MenuElementType46 = MenuElementBase & {
    type: 46;
    params: MenuElementParamsType46;
};

export type MenuElementParamsType50 = {
    manufacturerParentId: number;
    description: string;
};

export type MenuElementType50 = MenuElementBase & {
    type: 50;
    params: MenuElementParamsType50;
};



export type ScheduleMultiRow = {
    startTime: number;
    defaultStartTime: number;
    endTime: number;
    defaultEndTime: number;
    valueFirstColumn: number;
    defaultFirstColumn: number;
    valueSecondColumn: number | null;
    defaultSecondColumn: number | null;
};

export type ScheduleMultiColumn = {
    txtId: number;
    min: number;
    max: number;
    interval: number;
    type: number;
};

export type MenuElementParamsType100 = {
    dayId: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
    prevObjId: number;
    nextObjId: number;
    type: 0 | 1;
    step: number;
    numRows: number;
    numCols: number;
    cols: ScheduleMultiColumn[];
    rows: ScheduleMultiRow[];
    description: string;
    value?: number[];
};

export type MenuElementType100 = MenuElementBase & {
    type: 100;
    params: MenuElementParamsType100;
};

export type MenuElementParamsType106 = {
    format: number;
    value: number;
    min: number;
    max: number;
    default: number;
    txtId: number;
    description: string;
    jump: number;
};

export type MenuElementType106 = MenuElementBase & {
    type: 106;
    params: MenuElementParamsType106;
};

export type MenuElementParamsType107 = {
    day: number;
    month: number;
    year: number;
    description: string;
};
export type MenuElementType107 = MenuElementBase & {
    type: 107;
    params: MenuElementParamsType107;
};

export type MenuElementParamsType108 = {
    remoteReset: boolean;
    startDay: number;
    startMonth: number;
    startYear: number;
    endDay: number;
    endMonth: number;
    endYear: number;
    description: string;
};

export type MenuElementType108 = MenuElementBase & {
    type: 108;
    params: MenuElementParamsType108;
};

export type MenuElementParamsType109 = {
        editable: 0 | 1;
        format: 1 | 2;
        values: number[];
        description?: string;
        day?: number;
        month?: number;
        year?: number;
};

export type MenuElementType109 = MenuElementBase & {
    type: 109;
    params: MenuElementParamsType109;
};

export type MenuElementParamsType112 = {
    value: number;
    default: number;
    options: CheckboxOption[];
    description: string;
};

export type MenuElementType112 = MenuElementBase & {
    type: 112;
    params: MenuElementParamsType112;
};

export type MenuElementsParamsType120 = {
    type: '0' | '1';
    days: Array<ScheduleInterval[]>;
};

export type MenuElementType120 = MenuElementBase & {
    type: 120;
    params: MenuElementsParamsType120;
};

export type ScheduleMenuElement = MenuElementType12 | MenuElementType13 | MenuElementType100;
export type CheckboxesMenuElement = MenuElementType11_111 | MenuElementType112;
export type OneSwitchMenuElement = MenuElementType1_5 | MenuElementType106;
